<t-llevo-dialog-header [dialogTitle]="dialogTitle"></t-llevo-dialog-header>

<mat-dialog-content commonui-loader [appLoader]="loading$() || false">
  <mat-stepper
    [linear]="isLinear"
    #stepper
    [(selectedIndex)]="selectedStepIndex"
  >
    @for(step of steps(); track step.component){
        <mat-step [stepControl]="getFormControl(step.controlName)">
            <ng-template matStepLabel>{{step.label}}</ng-template>
            <ng-container
              [ngComponentOutlet]="step.component" 
              [ngComponentOutletInputs]="
                {
                  frm: getFormControl(step.controlName),
                  loaderSrv: loaderSrv,
                  focusOnFirstInput: selectedStepIndex === $index? true : false
                }
              ">
            </ng-container>
        </mat-step>
    }
  </mat-stepper>
</mat-dialog-content>

<mat-dialog-actions class="step-actions">
  <div>
    @if(selectedStepIndex != 0){
    <button 
      mat-button 
      (click)="selectPreviusStep()" 
      type="button"
      [disabled]="loading$() || false"
    >
      Atrás
    </button>
    }
  </div>

  <div>
    @if(selectedStepIndex != stepperLastIndex()){
      <button 
        mat-button 
        (click)="selectNextStep()" 
        type="submit"
        [disabled]="loading$() || false"
      >
    		Siguiente
  		</button>
    } 
		@else {
			<button 
        mat-flat-button 
        type="submit" 
        color="accent" 
        (click)="onSubmit()"
        [disabled]="loading$() || false"
      >
				Guardar
			</button>
    }
  </div>
</mat-dialog-actions>